import { clientWithApiClient } from "../../client";
import type { ApiClient, ListResponse, Response } from "../../types";
import type {
  InsuranceOptionGroup,
  CreateInsuranceOptionGroupRequest,
  UpdateInsuranceOptionGroupRequest,
  ReorderLayoutRequest,
} from "./types";

const BASE_PATH = "/insurance-option-groups";

const withFleet = (path: string, fleetId: string) => {
  const searchParams = new URLSearchParams();
  searchParams.append("fleet_id", fleetId);
  return `${path}?${searchParams.toString()}`;
};

export const insuranceOptionGroups = {
  list: async (client: ApiClient, fleetId: string) =>
    clientWithApiClient<ListResponse<InsuranceOptionGroup>>(
      client,
      withFleet(BASE_PATH, fleetId),
    ),

  create: async (
    client: ApiClient,
    fleetId: string,
    data: CreateInsuranceOptionGroupRequest,
  ) =>
    clientWithApiClient<Response<InsuranceOptionGroup>>(
      client,
      withFleet(BASE_PATH, fleetId),
      {
        method: "POST",
        body: JSON.stringify({ insurance_option_group: data }),
      },
    ),

  update: async (
    client: ApiClient,
    fleetId: string,
    id: string,
    data: UpdateInsuranceOptionGroupRequest,
  ) =>
    clientWithApiClient<Response<InsuranceOptionGroup>>(
      client,
      withFleet(`${BASE_PATH}/${id}`, fleetId),
      {
        method: "PATCH",
        body: JSON.stringify({ insurance_option_group: data }),
      },
    ),

  /**
   * Deleting a group never deletes its options: they fall back to
   * ungrouped. Destroying a tier by removing its container would be a
   * surprising amount of damage for a reversible layout action.
   */
  delete: async (client: ApiClient, fleetId: string, id: string) =>
    clientWithApiClient(client, withFleet(`${BASE_PATH}/${id}`, fleetId), {
      method: "DELETE",
    }),

  reorderLayout: async (
    client: ApiClient,
    fleetId: string,
    data: ReorderLayoutRequest,
  ) =>
    clientWithApiClient<ListResponse<InsuranceOptionGroup>>(
      client,
      withFleet(`${BASE_PATH}/reorder`, fleetId),
      {
        method: "POST",
        body: JSON.stringify({ layout: data }),
      },
    ),
};
